jQuery(function($){

    $('#site-nav ul.menu > li > .sub-menu > li.menu-item-has-children').on('mouseenter', function(){

        let $this = $(this);

        setTimeout(function(){

            var parentPos = $this.closest('.sub-menu').offset();
            var childPos = $this.offset();
            var childOffset = {
                top: childPos.top - parentPos.top,
                left: childPos.left - parentPos.left
            };
            
            $this.find('> .sub-menu').css('paddingTop', childOffset.top);

            let submenu_height = $this.find('> .sub-menu').height() + childOffset.top;
            $this.parent().height(submenu_height);

        }, 10);

    })

    $('#site-nav ul.menu > li > .sub-menu > li.menu-item-has-children').on('mouseleave', function(){

        let $this = $(this);
            
        $this.parent().css({height: ""});

    })

});